import * as navigation from 'Navigation';

export class EmptyEntryTabState extends navigation.TabState {
  override defaults(): navigation.TabStateDefaults {
    return {
      ...super.defaults(),
      title: 'No Protocols',
      closeable: false,
      options: false,
      showInNavBar: false,
      preferenceKey: 'empty-entry',
    };
  }
}
